// extracted by mini-css-extract-plugin
export default {"config":"Configure_config__L4qX2","glow_on_hover":"Configure_glow_on_hover__AKiIX","glowing":"Configure_glowing__Ni2QF"};